import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";
import { __API_URL__ } from "../SERVER_URL";

const deleteExternalDoc = async (documentId) => {
  const token = localStorage.getItem("token");

  await axios.delete(`${__API_URL__}/api/patient/patient/delete_additional_doc/${documentId}/`, {
    headers: { Authorization: `Token ${token}` },
  });
};

const useDeleteExternalDocMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteExternalDoc,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["external-docs"] });
      queryClient.invalidateQueries({ queryKey: ["external-docs-summary"] });
      toast.success("Document deleted successfully");
    },
    onError: () => {
      toast.error("Failed to delete document");
    },
  });
};

export default useDeleteExternalDocMutation;
